import superagent from "superagent";
import config from "../config/config";

const methods = ["get", "post", "put", "patch", "delete"];

function formatUrl(path) {
  if (path.indexOf("http") === 0) {
    return path;
  }
  const adjustedPath = path[0] !== "/" ? "/" + path : path;
  if (path.indexOf(config.apiVersion) === 0) {
    if (config.useSiteUrl) {
      return (
        window.location.protocol +
        "//" +
        window.location.hostname +
        config.apiVersion +
        adjustedPath.replace(config.apiVersion, "")
      );
    } else {
      return config.baseUrl + adjustedPath.replace(config.apiVersion, "");
    }
  } else {
    return adjustedPath;
  }
}

class ApiClient {
  constructor() {
    methods.forEach(
      (method) =>
        (this[method] = (path, { params, data, auth } = {}) =>
          new Promise((resolve, reject) => {
            let request = superagent[method](formatUrl(path));

            if (auth && auth.token) {
              request.set("Authorization", "Bearer " + auth.token);
            } else if (this.token) {
              request.set("Authorization", "Bearer " + this.token);
            }

            request.set("Content-Type", "application/json");

            if (params) {
              request.query(params);
            }

            let delay = undefined;
            if (data && data.delay) {
              delay = data.delay;
              delete data.delay;
            }

            if (data) {
              request.send(data);
            }

            if (path.indexOf(".json") === -1) {
              request.end((err, { body } = {}) =>
                err
                  ? reject(body ? { ...body, status: err.status } : err)
                  : delay
                  ? setTimeout(() => {
                      resolve(body);
                    }, delay)
                  : resolve(body)
              );
            } else {
              request.end((err, res) => {
                if (res.ok) {
                  try {
                    resolve(JSON.parse(res.text));
                  } catch (e) {
                    resolve(res.text);
                  }
                }
              });
            }
          }))
    );
  }
}

export default ApiClient;
